import { Suspense, useEffect, useMemo } from 'react';
import { CursorProvider } from '@/chrome/Cursor/CursorProvider';
import { DevTools } from '@/dev/DevTools';
import { parseFaceParam, parseLevelParam } from '@/dev/urlParams';
import { useAnalytics } from '@/hooks/useAnalytics';
import { LevelShell } from '@/levels/LevelShell';
import { resolveLevel } from '@/levels/LevelRegistry';
import { resolveV2Event } from '@/levels/V2EventRegistry';
import { useGameStore } from '@/state/gameStore';
import { selectActiveV2Event, selectCurrentLevel } from '@/state/selectors';

export function App() {
  const currentLevel = useGameStore(selectCurrentLevel);
  const activeV2Event = useGameStore(selectActiveV2Event);
  const Current = useMemo(() => resolveLevel(currentLevel), [currentLevel]);
  const CurrentV2Event = useMemo(
    () => (activeV2Event === null ? null : resolveV2Event(activeV2Event)),
    [activeV2Event]
  );

  useAnalytics();

  useEffect(() => {
    if (import.meta.env.PROD) return;
    const params = new URLSearchParams(window.location.search);

    const level = parseLevelParam(params.get('level'));
    if (level != null) useGameStore.getState().advanceTo(level);

    const face = parseFaceParam(params.get('face'));
    if (face != null) useGameStore.getState().setFaceState(face);
  }, []);

  return (
    <CursorProvider>
      <LevelShell id={currentLevel}>
        <Suspense fallback={<div data-testid="level-loading" aria-hidden="true" />}>
          {CurrentV2Event === null ? <Current /> : <CurrentV2Event />}
        </Suspense>
      </LevelShell>
      <DevTools />
    </CursorProvider>
  );
}
